import{DefaultColor3 as e,DefaultColor4 as o,DefaultColor5 as t}from"@openremote/core";import{css as r,html as i,unsafeCSS as l}from"lit";export const baseStyle=r`
  :host {
    flex: 1;
  }

  .item-container {
    display: flex;
  }

  .delete-container,
  .drag-container {
    width: 30px;
    display: flex;
    vertical-align: middle;
  }

  .item-container:hover .button-clear,
  .item-wrapper:hover .button-clear {
    visibility: visible;
  }

  .no-match-container {
    align-items: center;
  }

  .no-match-container > *:not(:last-child) {
    margin-right: 10px;
  }

  .button-clear {
    background: none;
    color: ${l(t)};
    --or-icon-fill: ${l(t)};
    visibility: hidden;
    display: inline-block;
    border: none;
    padding: 0 0 0 5px;
    cursor: pointer;
  }
  .button-clear:hover {
    --or-icon-fill: ${l(o)};
  }
  .button-clear:focus {
    outline: 0;
  }
  .button-clear.hidden {
    visibility: hidden;
  }

  .any-of-picker {
    width: 100%;
  }

  #errors {
    color: red;
    margin-right: 10px;
    flex: 1;
    display: flex;
    align-items: center;
  }

  #errors > or-icon {
    margin-right: 5px;
  }
`;export const panelStyle=r`
  #header-description {
    flex: 1;
    display: flex;
    flex-direction: row;
  }

  #type-label {
    border: 1px solid var(--or-app-color4, green);
    border-radius: 3px;
    padding: 3px;
    margin-left: 10px;
  }

  #header-buttons {
    flex: 0;
  }

  #content-wrapper {
    flex: 1;
    padding: 0 4px 14px 24px;
  }

  #content {
    display: flex;
    flex-direction: column;
  }

  #content > * {
    flex: 1;
  }

  .item-container + .item-container {
    padding-top: 10px;
  }

  #footer {
    margin-top: 10px;
  }
`;export const addItemOrParameterDialogStyle=i`
  <style>
    .mdc-dialog__surface {
      width: 800px;
      overflow-x: visible !important;
      overflow-y: visible !important;
    }
    #dialog-content {
      border-color: var(--or-app-color5, ${l(t)});
      border-top-width: 1px;
      border-top-style: solid;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      padding: 0;
    }
    form {
      display: flex;
      height: 100%;
    }
    #type-list {
      overflow: auto;
      min-width: 150px;
      max-width: 300px;
      flex: 0 0 40%;
      border-right: 1px solid var(--or-app-color5, #ccc);
    }
    #parameter-list {
      display: block;
    }
    #parameter-title {
      text-transform: capitalize;
      color: var(--or-app-color3, ${l(e)});
      font-size: 18px;
      font-weight: bold;
    }
    #parameter-desc {
      padding: 15px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      overflow: auto;
    }
  </style>
`;